import * as React from "react";

import { ToasterContainer, toaster as baseToaster } from "baseui/toast";

import { Overrides } from "baseui/overrides";
import { useStyletron } from "kanopi-components/theme/useStyletron";

export function ToastContainer() {
  const [, theme] = useStyletron();
  return (
    <ToasterContainer
      placement="topRight"
      overrides={{
        Root: {
          style: {
            zIndex: theme.zIndex.modal + 1, // Make sure the toaster is above the modal
          },
        },
      }}
    />
  );
}

const KIND_MAPPING = {
  INFO: "info",
  WARNING: "warning",
  ERROR: "negative",
  POSITIVE: "positive",
};

const toaster = ({
  kind = "INFO",
  content,
  overrides = {},
  key,
  autoHideDuration = 5000,
}: {
  kind: keyof typeof KIND_MAPPING;
  content: Set<unknown> | string;
  overrides?: Overrides<unknown>;
  key?: string;
  autoHideDuration?: number;
}) => {
  // Fallback to default kind if invalid kind is supplied.
  const baseKind = KIND_MAPPING[kind] || "info";
  let hideDuration = autoHideDuration;
  if (["warning", "negative"].includes(baseKind)) {
    hideDuration = 0;
  }

  baseToaster[baseKind](content, {
    overrides,
    key,
    autoHideDuration: hideDuration,
  });
};

export { toaster };
